// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"9a1efddb","239":"60216727","344":"9c7ceef4","451":"60a6b6ed","455":"362ebe2a","809":"01ffb350","977":"ffd0d9da"}[chunkId] + ".chunk.js";
};